import React from 'react';
import Typography from '@mui/material/Typography';
import { Button, Divider, Modal } from '@mui/material';
import { ModalClose, Sheet } from '@mui/joy';
import { Box } from '@mui/system';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function ConfirmationPopup({ open, setOpen, label, onConfirm, ncrId = null }) {

  const contentMap = {
    NCDelete: {
      heading: "Delete",
      description: `Are you sure want to delete NC- ${ncrId || ''}?`,
      confirmText: "Delete",
      cancelText: "Cancel",
    },
    ForgotPassword: {
      heading: "Forgot password?",
      description: "Are you sure you want to request your password?",
      confirmText: "Yes",
      cancelText: "No",
    },
  };

  const { heading, description, confirmText, cancelText } = contentMap[label] || contentMap.NCDelete;

  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
      open={open}
      onClose={() => setOpen(false)}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <Sheet
        variant="outlined"
        sx={{ maxWidth: 500, borderRadius: 'md', boxShadow: 'lg' }}
      >
        <ModalClose size='lg' variant="plain" onClick={() => setOpen(false)} />
        <Typography component="h2" sx={{
          fontFamily: 'Lato, sans-serif',
          fontSize: '16px',
          fontWeight: '700',
          color: '#000000',
          px: 3,
          py: 0.8,
          mt: 1
        }}>
          {heading}
        </Typography>
        <Divider sx={{ mb: 2, mt: 1 }} />
        <Box sx={label === 'NCDelete' ? { display: 'flex', alignItems: 'center', px: 3 } : {}}>
          {label === 'NCDelete' && <ErrorOutlineIcon sx={{ color: '#FF0000' }} />}
          <Typography className='forgot-password-popup-text' sx={{ px: label === 'NCDelete' ? 1 : 3 }}>
            {description}
          </Typography>
        </Box>
        <Box sx={{
          borderRadius: '0px 0px 10px 10px',
          boxShadow: '0px -1px 4px 0px #00000026',
          textAlign: 'right',
          px: 3,
          py: 1.5,
          mt: 3,
        }}>
          <Button
            variant="outlined"
            color="neutral"
            sx={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '14px',
              fontWeight: '700',
              border: '1px solid #0E2966 !important',
              textTransform: 'none',
              borderRadius: '7px',
              color: '#0E2966 !important',
              px: 2,
              mr: 2
            }}
            onClick={() => setOpen(false)}
          >
            {cancelText}
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              setOpen(false);
            }}
            sx={{
              fontFamily: 'Lato, sans-serif',
              background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
              color: 'white',
              textTransform: 'none',
              borderRadius: '7px',
              px: 2,
            }}
          >
            {confirmText}
          </Button>
        </Box>
      </Sheet>
    </Modal>
  );
}